import { ArtData } from '@/database/art'
import { custodial, nonBreakingSpace, uni1d800 } from '@/utils/extras'
import { ArtState } from '@/database/types'
import React from 'react'

export const formatDateString = (dateString: string): string => {
    const date = new Date(dateString)
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
        timeZone: 'UTC',
    }
    return date.toLocaleString(undefined, options)
}

export const formatDate = (date: Date | string | number): string => {
    const dateObj = new Date(date)

    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
        timeZone: 'UTC',
    }
    return dateObj.toLocaleDateString('en-US', options)
}

export const priceText = (artData: ArtData, style = '') => {
    if (artData?.state === ArtState.NOT_FOR_SALE && artData?.currentOwner !== custodial) {
        return <span className="white">&nbsp;Not&nbsp;for&nbsp;sale</span>
    }
    return crazyAmount(artData?.art.price ? artData?.art.price.toFixed(2) : undefined, style)
}

export const transferFeeText = (artData: ArtData) => {
    return (
        <React.Fragment>
            {artData?.art.transferFee ? (
                <span className={uni1d800.className + ' white'}>{'\u200C\uD836\uDE17'}</span>
            ) : (
                ''
            )}
            {artData?.art.transferFee ? <span>{artData.art.transferFee}</span> : 'No Fee'}
        </React.Fragment>
    )
}

export const forSaleButtonText = (artData: ArtData) => {
    return (
        <div className="centered-button-text ">
            {artData.art.price > 0 ? (
                <div className={'centered-button-text '}>
                    <div className={'nav__balances_block '}>Own&nbsp;for&nbsp;</div>
                    {artData.art.price > 0 && (
                        <div className={uni1d800.className + ' nav__balances_block' + ' menu-wrapper-bottom'}>
                            {'\u200C\uD836\uDE17'}
                        </div>
                    )}
                </div>
            ) : (
                ''
            )}
            {artData.art.price > 0 ? <div className="">{artData.art.price}</div> : 'Own For Free'}
        </div>
    )
}

export const crazyAmount = (amount: string | undefined, style = '') => {
    return (
        <>
            {amount && amount.length > 0 && parseFloat(amount) > 0 ? (
                <div>
                    <span className={uni1d800.className + ' ' + style}>{'\u200C\uD836\uDE17'}</span>
                    {amount}
                </div>
            ) : (
                <div>
                    <span className={uni1d800.className + ' ' + style}>{'\u200C\uD836\uDE17'}</span>
                    <span>&nbsp;-&nbsp;</span>
                </div>
            )}
        </>
    )
}
export const formatTime = (seconds: number) => {
    if (seconds < 60) {
        return seconds + 's'
    } else if (seconds < 3600) {
        const minutes = Math.floor(seconds / 60)
        const remainingSeconds = seconds % 60
        return minutes + 'm' + nonBreakingSpace + remainingSeconds + 's'
    } else {
        const hours = Math.floor(seconds / 3600)
        const remainingMinutes = Math.floor((seconds % 3600) / 60)
        return hours + 'h' + nonBreakingSpace + remainingMinutes + 'm' + nonBreakingSpace
    }
}
